export const styles = ({
  radio: {
    '&$checked': {
      color: '#EB9937',
    },
    '&$label': {
      color: '#81A7BB',
    },
  },
  checked: {},
  label: {
    color: '#81A7BB',
  },
  radioMargin: {
    marginTop: '-1rem',
  },
  radioMargin1: {
    marginTop: '0rem',
  },
});